module.exports = __webpack_public_path__ + "static/img/articlepages.9c87148b.svg";